import {useTranslation} from "react-i18next"
import {isEmpty} from "lodash"
import {Icon} from "components/Icon"
import {getFullNameWithEnrollmentId} from "helpers"
import {studentStaffContactsServiceV3} from "services"
import styles from "./AdvisorsPopup.module.css"
import {BaseLoading} from "components"

type Staff = {
    staffProfileId: number
    firstName: string
    middleName: string
    lastName: string
    photo: string
    studentStaffContactId: number
    studentStaffContactRoleId: number
    studentProfileId: number
    isDefault: number
    add?: boolean
    remove?: boolean
    edit?: boolean
}

type Props = {
    nonCampusSelectedAdvisors: any[]
    getStaffs: () => Promise<void>
    isLoading: boolean
}

export function NonCampusAdvisors(props: Props) {
    const {nonCampusSelectedAdvisors, isLoading, getStaffs} = props
    const {t} = useTranslation(["common"])

    const removeNonCampusAdvisor = async (advisor: Staff) => {
        if (advisor.studentStaffContactId) {
            await studentStaffContactsServiceV3.delete([advisor.studentStaffContactId])
            await getStaffs()
        }
    }

    if (isEmpty(nonCampusSelectedAdvisors)) {
        return null
    }

    if (isLoading) {
        return <BaseLoading isShow />
    }

    return (
        <div className={styles.tableWrapper}>
            <p className={styles.headerTitle}>Selected Advisors from Other Campuses</p>
            <table className={styles.nonCampusTable}>
                <thead className={styles.titleColor}>
                    <tr>
                        <th>{t("advisorsPopup.staff")}</th>
                        <th className={styles.columnSize}>{t("advisorsPopup.title")}</th>
                        <th className={styles.columnSize}>{t("advisorsPopup.default")}</th>
                        <th>{t("advisorsPopup.role")}</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {nonCampusSelectedAdvisors.map((advisor, index) => (
                        <tr key={advisor.studentStaffContactId || index} className={styles.tableRow}>
                            <td>
                                <div className={styles.fullnameWrap}>
                                    <img
                                        src={advisor.photo || "/image/DefaultAvatar.png"}
                                        alt=""
                                        className={styles.avatar}
                                    />
                                    <p className={styles.fullname}>{getFullNameWithEnrollmentId(advisor)}</p>
                                </div>
                            </td>
                            <td className={styles.textAlignLeft}>{advisor.title}</td>
                            <td>
                                <div className={styles.defaultWrap}>
                                    {!!advisor.isDefault && (
                                        <div className={styles.primaryLabelWrap}>
                                            <label className={styles.defaultLabel}>Primary</label>
                                        </div>
                                    )}
                                </div>
                            </td>
                            <td className={styles.textAlignLeft}>{advisor.roleName}</td>
                            <td>
                                <div className={styles.checkIconWrap} onClick={() => removeNonCampusAdvisor(advisor)}>
                                    <Icon icon="CLOSE" color="#ff4d4f" className={styles.clearIcon} />
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}
